/**
 * Utilitaires pour les modules
 * Basé sur le document d'analyse et conception SyncMP
 */
import dashboardIcon from '../../assets/img3d/dashboard.png'
import buildingIcon from '../../assets/img3d/building.png'
import stockIcon from '../../assets/img3d/stock.png'
import coinsIcon from '../../assets/img3d/coins.png'
import reportIcon from '../../assets/img3d/report.png'
import maintenanceIcon from '../../assets/img3d/maintenance.png'
import profileClientIcon from '../../assets/img3d/profileClient.png'
import calendarIcon from '../../assets/img3d/calendar.png'
import fileTextIcon from '../../assets/img3d/contrat.png'
import homeIcon from '../../assets/img3d/home.png'
import chatIcon from '../../assets/img3d/chat.png'

/**
 * Retourne le chemin de l'image pour un module donné
 */
export function getModuleIconImage(moduleId: string): string {
  const imageMap: Record<string, string> = {
    users: profileClientIcon,
    configuration: buildingIcon,
    ressources: stockIcon,
    transactions: coinsIcon,
    couts: reportIcon,
    'calcul-financier': dashboardIcon,
    dashboard: dashboardIcon,
    'dashboard-professional': dashboardIcon,
    'dashboard-admin': dashboardIcon,
    settings: maintenanceIcon,
    'my-requests': fileTextIcon,
    'my-visits': calendarIcon,
    'my-properties': homeIcon,
    'calendar-visits': calendarIcon,
    'calendar-visits-admin': calendarIcon,
    'my-leads': profileClientIcon,
    'contact-requests': fileTextIcon,
    'communications': chatIcon
  }
  
  return imageMap[moduleId] || dashboardIcon
}

